import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    position: 'relative', 
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    marginBottom: `calc(24px + env(safe-area-inset-bottom))`,

    ['@media (max-width:425px)']: {
      overflowX: 'scroll',
    },
    ['@media (max-width:375px)']: {
      overflowX: 'scroll',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '30px',
      background: 'linear-gradient(to bottom, rgba(219, 0, 1, 0.08), rgba(219, 0, 1, 0))',
      pointerEvents: 'none',
    },
  },
  menuButtons: {
    margin: '0 2rem',
  },
}));
